import * as React from 'react';
import { TextInput, HiddenInput } from 'soprasteria-ui-library';
import { IPatient } from '../../../../models/IPatient';
import { formatAddress } from '../../../../helpers/AddressHelper';
import { IOrthodonticReferral } from '../../../../models/IOrthodonticReferral';
import { formatPersonalSecurityNumberAndOrganisationNumber } from "../../../../helpers/PersonalSecurityNumberAndOrganisationNumberHelper";

interface IOrthodonticReferralPatientInformation {
    patient: IPatient;
    orthodonticReferral: IOrthodonticReferral;
}

export const OrthodonticReferralPatientInformation: React.FunctionComponent<IOrthodonticReferralPatientInformation> = ({ patient, orthodonticReferral }) => {

    return (
        <>
            <div className={`row ${orthodonticReferral.canEdit ? "" : "readonly-less-margin"}`}>
                <h5 className="col-12">Patientinformation</h5>
                <HiddenInput name="patientId" value={patient.patientId.toString()} />
                <div className="col-6">
                    <TextInput name="readonlyPatientName" label="Namn" defaultValue={patient.name} inlineLabel readonly />
                </div>
                <div className="col-6">
                    <TextInput name="readonlyPatientPnr" label="Personnummer" defaultValue={formatPersonalSecurityNumberAndOrganisationNumber(patient.personalSecurityNumber)} inlineLabel readonly />
                </div>
                <div className="col-6">
                    <TextInput name="readonlyPatientAddress" label="Adress" defaultValue={formatAddress(patient.address)} inlineLabel readonly />
                </div>
                <div className="col-6">
                    <TextInput name="patientTelePhoneNumber" label="Telefonnummer" defaultValue={orthodonticReferral.patientPhoneNumber ?? (!orthodonticReferral.canEdit ? "Saknas" : "")} maxLength={30} inlineLabel readonly={!orthodonticReferral.canEdit} />
                </div>
                <div className="col-6">
                    <TextInput name="patientCellPhoneNumber" label="Mobilnummer" defaultValue={orthodonticReferral.patientCellPhoneNumber ?? (!orthodonticReferral.canEdit ? "Saknas" : "")} maxLength={30} inlineLabel readonly={!orthodonticReferral.canEdit} />
                </div>
                <div className="col-6">
                    <TextInput name="patientEmail" label="E-post" defaultValue={orthodonticReferral.patientEmail ?? (!orthodonticReferral.canEdit ? "Saknas" : "")} maxLength={100} inlineLabel readonly={!orthodonticReferral.canEdit} />
                </div>
            </div>
            <hr />
        </>
    )
}